import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Toaster } from './components/ui/sonner';
import { ThemeProvider } from './context/ThemeContext';

import Header from './components/Header';
import Hero from './components/Hero';
import About from './components/About';
import Skills from './components/Skills';
import Publications from './components/Publications';
import Experience from './components/Experience';
import Achievements from './components/Achievements';
import Contact from './components/Contact';
import Footer from './components/Footer';
import ChatBot from './components/ChatBot';

const Portfolio = () => (
  <div className="min-h-screen bg-[hsl(var(--background))] text-[hsl(var(--foreground))]">
    <Header />
    <main>
      <Hero />
      <About />
      <Experience />
      <Skills />
      <Publications />
      <Achievements />
      <Contact />
    </main>
    <Footer />
    <ChatBot />
    <Toaster />
  </div>
);

function App() {
  return (
    <ThemeProvider>
      <div className="App">
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Portfolio />} />
          </Routes>
        </BrowserRouter>
      </div>
    </ThemeProvider>
  );
}

export default App;
